const HEADER_ALIASES = {
  clientCode: ['client code', 'clientcode', 'code'],
  clientName: ['client name', 'clientname', 'client'],
  services: ['type of service', 'services', 'service type'],
  location: ['location'],
  name: ['spoc name', 'name', 'contact name'],
  email: ['spoc email', 'email'],
  mobileNumber: ['spoc mobile', 'mobile number', 'mobile', 'phone'],
};

function normalizeHeader(header) {
  return String(header || '').trim().toLowerCase();
}

export function getClientImportRowValue(row, fieldKey) {
  const aliases = HEADER_ALIASES[fieldKey] || [fieldKey];
  for (const [header, value] of Object.entries(row || {})) {
    const normalized = normalizeHeader(header);
    if (aliases.includes(normalized) || normalized === fieldKey.toLowerCase()) {
      return value;
    }
  }
  return row?.[fieldKey] ?? '';
}

export const CLIENT_IMPORT_COLUMNS = [
  { key: 'clientCode', label: 'Client Code' },
  { key: 'clientName', label: 'Client Name' },
  { key: 'services', label: 'Type Of Service' },
  { key: 'location', label: 'Location' },
  { key: 'name', label: 'SPOC Name' },
  { key: 'email', label: 'SPOC Email' },
  { key: 'mobileNumber', label: 'SPOC Mobile' },
];

export const CLIENT_IMPORT_EXAMPLE = {
  clientCode: 'DEMO01',
  clientName: 'Demo Client 01',
  services: 'IT Staffing',
  location: 'Bangalore',
  name: 'SPOC 01',
  email: 'spoc01@demo.com',
  mobileNumber: '9876543210',
};

export function mapClientImportRowToPayload(row) {
  return {
    ClientCode: String(getClientImportRowValue(row, 'clientCode') || '').trim(),
    ClientName: String(getClientImportRowValue(row, 'clientName') || '').trim(),
    Services: String(getClientImportRowValue(row, 'services') || 'IT Staffing').trim(),
    Location: String(getClientImportRowValue(row, 'location') || '—').trim(),
    Name: String(getClientImportRowValue(row, 'name') || '').trim(),
    Email: String(getClientImportRowValue(row, 'email') || '').trim(),
    MobileNumber: String(getClientImportRowValue(row, 'mobileNumber') || '').trim(),
    Spoc: String(getClientImportRowValue(row, 'name') || '').trim(),
  };
}

export function buildClientImportPayloads(rows = []) {
  return rows
    .map((row) => mapClientImportRowToPayload(row))
    .filter((payload) => payload.ClientCode && payload.ClientName);
}
